export {
  DEFAULT_POST_LOGIN_ROUTE,
  PARTNER_POST_LOGIN_ROUTE,
  resolvePostLoginRoute,
  safeNextTarget,
} from "./safeNextTarget";
